var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 20V2m8.005 12l-8 8-8-8","fill":"none","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"}));
}

ArrowDownInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
